import { MessageBar, MessageBarType } from '@fluentui/react';
import { useDownloadData } from '../context';
import { useTranslation } from 'react-i18next';

/**
 * Renders a warning banner if the user is trying to download a large dataset.
 */
export const WarningBanner = ({
  downloadClicked,
}: {
  downloadClicked: boolean;
}) => {
  const [t] = useTranslation('download');
  const { isLarge, percent } = useDownloadData();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column-reverse',
      }}
    >
      {isLarge && percent < 0.9 && (
        <MessageBar messageBarType={MessageBarType.info}>
          {t(
            'warning large',
            'You are trying to download a large dataset, this will take a long time!'
          )}
        </MessageBar>
      )}
      {percent > 0.99 && downloadClicked && (
        <MessageBar>{t('Download complete')}</MessageBar>
      )}
    </div>
  );
};
